const selectors = {
  block: "[data-login]",
};

const initBlock = (block) => {
  const inputs = block.querySelectorAll("#user_login, #user_pass");

  inputs?.forEach((input) => {
    input.setAttribute("placeholder", input.previousElementSibling.textContent);
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
